<template>
  <router-link
    :class="$root.listItemClasses"
    :to="{
      name: 'purchase',
      params: {
        purchaseId: purchase.id
      }
    }"
  >
    {{ $root.displayDateTimeFmt(purchase.purchased_at) }}:
    {{ purchase.purchasable_items.map(pi => pi.attributes.name).join(", ") }}
    {{ purchase.gift ? $root.giftIcon : '' }}
    <span
      v-if="showBuyer"
    >
      ({{ purchase.customer_email }})
    </span>
  </router-link>
</template>
<script>
export default {
  props: {
    purchase: {
      type: Object,
      default: () => {}
    },

    showBuyer: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.purchase {
  background-color: #F5BCB2;
  margin-bottom: 0.25em;
}
.purchase.pending {
  background-color: #E7F599
}

.purchase.send_confirmation {
  background-color: #A1DBF5
}

.purchase.completed {
  background-color: #B1F5AE
}

.purchase.created {
  background-color: #F5CD94
}

.purchase.gift {
  background-color: #F5C1E8
}

.purchase-key span {
  margin: 0 0.25rem
}

.no-key:nth-child(odd) {
   background-color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseListItem.vue